import { capitalize, filter, get, sortBy } from 'lodash';
import React from 'react';

import { Delete } from '../shared/rowActions/Delete';
import ScheduledReportsEmptyState from './ScheduledReportsEmptyState';
import scheduledReportsResource from 'src/actions/scheduledReports/scheduledReportsResource';
import TablePage, { TablePageRender } from '../shared/TablePage';
import useResource, { isLoadingStatus } from 'src/presentation/hooks/useResource';

const columnConfig = [
  { attr: 'name', label: 'Email Subject' },
  { attr: 'frequency', label: 'Delivery Schedule' },
  { attr: 'createdAt', label: 'Created On' },
];

function renderRowActions({ item }) {
  return (
    <>
      <Delete
        confirmationText="Delete this scheduled report?"
        deleteAction={scheduledReportsResource.effects.remove}
        description="Deleting this scheduled report cannot be undone."
        id={item.id}
        submitText="Delete Scheduled Report"
      />
    </>
  );
}

const ScheduledReports: TablePageRender = ({ root }) => {
  const { errors, loadingState, values } = useResource(scheduledReportsResource);

  const convertRow = row => {
    return {
      id: row.id,
      name: get(row, 'reportParameters.name', ''),
      frequency: capitalize(get(row, 'reportParameters.frequency', '')),
      createdAt: new Date(row.createdAt).toLocaleDateString(),
    };
  };

  const reports = values ? values.map(convertRow) : [];
  const sortedReports = sortBy(reports, item => item.name);
  const description = (
    <span>
      View and delete reports that are sent to you and your team members.{' '}
      <a target="_blank" rel="noopener noreferrer" href="https://help.gladly.com/docs/edit-scheduled-reports/">
        Learn more about managing scheduled reports
      </a>
      .
    </span>
  );

  function filterFunc(items, searchString) {
    if (!searchString) {
      return items;
    }

    return filter(items, item => {
      return get(item, 'name', '').toLowerCase().indexOf(searchString.toLowerCase()) > -1;
    });
  }

  return (
    <TablePage
      columnConfig={columnConfig}
      emptyState={ScheduledReportsEmptyState}
      errors={errors}
      filterFunc={filterFunc}
      isLoading={isLoadingStatus(loadingState)}
      resetErrors={scheduledReportsResource.actions.resetErrors}
      items={sortedReports}
      name="Scheduled Reports"
      description={description}
      root={root}
      renderRowActions={renderRowActions}
      data-aid="scheduled-reports-page"
    />
  );
};

export default ScheduledReports;
